var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect, useMemo, useRef } from 'react';
import { useCombinedRefs } from '../../util';
import { Container, Divider, OverflowDots } from './elements';
export var Breadcrumb = forwardRef(function (_a, fRef) {
    var children = _a.children, maxItems = _a.maxItems, _b = _a.showOverflowDots, showOverflowDots = _b === void 0 ? false : _b, ariaLabel = _a.ariaLabel, rest = __rest(_a, ["children", "maxItems", "showOverflowDots", "ariaLabel"]);
    var innerRef = useRef();
    var combinedRef = useCombinedRefs(fRef, innerRef);
    var breadcrumbChildren = useMemo(function () {
        return maxItems ? React.Children.toArray(children).slice(-maxItems) : children;
    }, [children, maxItems]);
    var childrenCount = React.Children.count(breadcrumbChildren);
    var breadcrumbItems = useMemo(function () {
        return React.Children.map(breadcrumbChildren, function (child, index) { return (React.createElement("li", { "aria-current": "page", key: index },
            child,
            index < childrenCount - 1 && React.createElement(Divider, null))); });
    }, [breadcrumbChildren]);
    useEffect(function () {
        var _a, _b;
        var lastElementChild = innerRef.current.lastElementChild
            .lastElementChild;
        (_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.scroll) === null || _b === void 0 ? void 0 : _b.call(_a, lastElementChild.offsetLeft, 0);
    }, []);
    return (React.createElement(Container, __assign({ "aria-label": ariaLabel || 'breadcrumb', ref: combinedRef }, rest),
        showOverflowDots && React.createElement(OverflowDots, null, "..."),
        breadcrumbItems));
});
